<div class=" dashboard page-holder bg-gray-100">
    <div class="container-fluid px-lg-4 px-xl-5 min-w-viewport">
      <section class="mb-4 mb-lg-4">
        <select class="form-select form-select-sm d-inline w-auto mb-1 mb-lg-2 me-lg-3 " name="businessUnit">
            <option>All BUs</option>
            <option>BUA</option>
          </select>
          <select class="form-select form-select-sm d-inline w-auto mb-1 mb-lg-2 me-lg-3 " name="businessUnit">
            <option>All Facilities</option>
            <option>FacilityA</option>
          </select>
        <div class="row text-dark">
            <div class="col-lg-6 col-xl-6 mb-5 mb-lg-0" >
                <div class="card h-100">
                  <div class="card-header d-flex v-center">
                    <div class="me-3 text-lg text-danger"><i class="far fa-clock"></i></div>
                    <h6 class="card-heading">Inspections Due Today
                    </h6>
                  </div>
                  <div class="card-body d-flex">
                    <div class="m-auto"><div class="circle border-red d-flex-center"><div class="txt-inspection">06</div></div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="col-lg-6 col-xl-6 mb-5 mb-lg-0" >
                <div class="card h-100">
                    <div class="card-header d-flex v-center">
                        <div class="me-3 text-lg txt-blue"> <i class="far fa-file"></i></div>
                        <h6 class="card-heading">Upcoming Inspection This Week</h6>
                  </div>
                  <div class="card-body d-flex">
                    <div class="m-auto"> <div class="circle border-blue d-flex-center"><div class="txt-inspection">14</div></div>
                  </div>
                  </div>
                </div>
            </div>
        </div>
      </section>
      <section class="mb-4">
        <div class="row">
            <div class="col-lg-6 col-xl-6 mb-5 mb-lg-0" >
                <div class="card h-100">
                    <div class="card-header d-flex v-center">
                        <div class="me-3 text-lg text-danger"> <i class="far fa-bell"></i></div>
                        <h6 class="card-heading">Parameters Exeeding Threshold</h6>
                  </div>
                  <div class="card-body d-flex">
                    <div class="m-auto"><div class="d-flex-center min-h txt-inspection">10</div></div>
                  </div>
                 
                </div>
            </div>
             <div class="col-lg-6 col-xl-6 mb-5 mb-lg-0" >
                <div class="card h-100">
                    <div class="card-header d-flex v-center">
                        <div class="me-3 text-lg text-success">  <i class="far fa-check-circle"></i></div>
                        <h6 class="card-heading">Forms Submitted Today</h6>
                  </div>
                  <div class="card-body d-flex">
                    <div class="chart-container" style="height:134px; width:320px;margin: auto;">
                        <canvas id="donut-submittedForms"></canvas>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </section>
    </div>
    <app-footer class="footer-w"></app-footer>
  </div>